"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterButton = void 0;
const components_1 = require("@apitable/components");
const icons_1 = require("@apitable/icons");
const react_1 = __importDefault(require("react"));
const FilterButton = (props) => {
    const { onClick, children } = props;
    const colors = (0, components_1.useThemeColors)();
    return (react_1.default.createElement(components_1.LinkButton, { prefixIcon: react_1.default.createElement(icons_1.AddOutlined, null), href: 'javascript:void(0)', underline: false, color: colors.secondLevelText, onClick: onClick }, children));
};
exports.FilterButton = FilterButton;
